// Utility to generate quarterly date/issue mappings
// Example: 144 = 10/01/2025, 143 = 07/01/2025, ...

export function getQuarterlyIssues(latestIssue = 144, latestDate = '10/01/2025', count = 12) {
    // latestDate in MM/DD/YYYY
    const [month, day, year] = latestDate.split('/').map(Number);
    const issues = [];
    let issueNum = latestIssue;
    let d = new Date(year, month - 1, day);
    for (let i = 0; i < count; i++) {
        const label = d.toLocaleDateString('en-US', { year: 'numeric', month: 'short' }); // 'Oct 2025'
        issues.push({ issue: issueNum, date: label });
        // Go back 3 months
        d.setMonth(d.getMonth() - 3);
        issueNum--;
    }
    return issues;
}
